import React, { useState, useEffect, useRef, useMemo, useId } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage";
import ColorPicker from "../Shared/ColorPicker.js";
import "./App.css";

const ColumnsConfiguration = ({ context, entityTypeId, ReloadStructureFunction }) => {

    const AppContext = context;

	const [widgets, setWidgets] = useState([]);
    const [widgetInstances, setWidgetInstances] = useState([]);
    const [apps, setApps] = useState([]);
    const [users, setUsers] = useState([]);
    const [showWidgetInstanceModal, setShowWidgetInstanceModal] = useState(false);
    const [tempWidgetInstances, setTempWidgetInstances] = useState(null);
    const [showAppsModal, setShowAppsModal] = useState(false);
    const [tempApps, setTempApps] = useState(null);
    const [isLoadingDashboard, setIsLoadingDashboard] = useState(true);
    const [isSavingWidgetInstances, setIsSavingWidgetInstances] = useState(false);
    const [isSavingApps, setIsSavingApps] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [isLoadingSearch, setIsLoadingSearch] = useState(false);
    const [showingAddWidgetModal, setShowingAddWidgetModal] = useState(false);
    const [addWidgetMenuRightPosition, setAddWidgetMenuRightPosition] = useState(0);
    const [isLoadingAddWidgetModal, setIsLoadingAddWidgetModal] = useState(false);
    const [isAddingWidgetInstace, setIsAddingWidgetInstace] = useState(null);
    const [isDeletingWidgetInstace, setIsDeletingWidgetInstance] = useState(null);
    const [systematicReviewsList, setSystematicReviewsList] = useState([]);
    const [selectedWidget, setSelectedWidget] = useState(null);
    const [chosenSystematicReview, setChosenSystematicReview] = useState(null);
    const [chosenSystematicReviewArea, setChosenSystematicReviewArea] = useState(null);
    const [instanceName, setInstanceName] = useState("");

    const [isSavingConfiguration, setIsSavingConfiguration] = useState(false);
    const [isLoadingSrs, setIsLoadingSrs] = useState(false);

    const [currentItemId, setCurrentItemId] = useState(null);
    const [newColumnType, setNewColumnType] = useState(0);
    const [newSSMSOptionValue, setNewSSMSOptionValue] = useState("");
    const [newSSMSOptionColor, setNewSSMSOptionColor] = useState("");
    const [newColumnSSMSOptions, setNewColumnSSMSOptions] = useState([]);
    const [newColumnName, setNewColumnName] = useState("");
    const [newColumnShowInTable, setNewColumnShowInTable] = useState(false);
    const [disabledNewColumnType, setDisabledNewColumnType] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [errorTitle, setErrorTitle] = useState(false);
    const [errorOptions, setErrorOptions] = useState(false);


    const uniqueId = useRef(1);

    
    /* WIDGET AND WIDGET INSTANCE METHODS */



    const loadWigetsData = () => {
        setIsLoadingDashboard(true);
        // Load Widget Instances
        let p1 = new Promise((resolve, reject) => {

            let url = "/umbraco/api/Home/WidgetInstances";

            fetch(url)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((data) => {

                    // Inject custom arguments for specific widgetInstances

                    data = data.map(widgetInstance => {

                        // Add custom params
                        widgetInstance = addCustomParamsToWidgetInstace(widgetInstance);

                        // Add icons
                        widgetInstance = addIconTo(widgetInstance);

                        return widgetInstance;

                    });


                    setWidgetInstances(data);
                    resolve();

                })
                .catch((error) => {
                    throw error;
                })
                .finally(() => {
                    setIsLoadingDashboard(false);
                });

        });

    }


    const openWidgetInstanceModal = () => {

        // No widget instances yet but opening the add widget instance menu? Then auto open the add widget menu also
        //if (widgetInstances.length == 0)
        //    openAddWidgetModal();
        //
        //setTempWidgetInstances(JSON.parse(JSON.stringify(widgetInstances)));
        //setShowWidgetInstanceModal(true);

        loadColumnsConfiguration();

    };


    const cancelWidgetInstanceModal = () => {
        setTempWidgetInstances(null);
        setShowingAddWidgetModal(false);
        setShowWidgetInstanceModal(false);
    };


    const saveWidgetInstanceModal = () => {

        setIsSavingWidgetInstances(true);

        let url = "/umbraco/api/CustomFields/FieldsConfiguration/?entityType=" + entityTypeId;

        let bodyObj = tempWidgetInstances;

        bodyObj = bodyObj.map(column => ({ ...column, Id: column.Id ? parseInt(column.Id) : column.Id })); // convert Ids back to int (maintain null for new)
        bodyObj = bodyObj.map(column => (column.IsSelectItemCheckbox ? { ...column, Name: "" } : column)); // remove name from checkbox column

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(bodyObj)
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then((response) => {
                loadColumnsConfiguration();
                setTempWidgetInstances(null);
                setShowWidgetInstanceModal(false);
                setShowingAddWidgetModal(false);
                setIsSavingWidgetInstances(false);

                ReloadStructureFunction(true); // true means it's a refresh on the reload structure function, not the first load

            })
            .catch((error) => {
                console.log("Error: " + error)
            })
            .finally(() => {
            });

    };


    const onWidgetInstanceDragEnd = (result) => {
        if (!result.destination) return;
        setTempWidgetInstances((prev) =>
            reorder(prev, result.source.index, result.destination.index)
        );
    };


    const toggleTempWidgetInstance = (id, status) => {
       
        setTempWidgetInstances((prev) =>
            prev.map((w) =>
                w.Id === id ? { ...w, ShowInTable: status } : w
            )
        );
    };


    const addWidgetInstance = (widgetId) => {

        setIsSavingConfiguration(true);
        let url = "/umbraco/api/Home/WidgetInstances?widgetId=" + widgetId;

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
               
                data = { ...data, Id: "" + data.Id };

                data = addCustomParamsToWidgetInstace(data);
                data = addIconTo(data);

                // Add widget to management menu
                data.Name = instanceName;
                const activeWidget = { ...data, IsActive: 1, Name: instanceName };
                setTempWidgetInstances([activeWidget, ...tempWidgetInstances]);

                const inactiveWidget = { ...data, IsActive: 0 };
                setWidgetInstances([inactiveWidget, ...widgetInstances]);


                
                data.Configurations = [
                    { WidgetInstanceId: data.Id, ConfigurationId: 1, Field: "Systematic Review", Value: chosenSystematicReview },
                ];

                let url = "/umbraco/api/Home/WidgetInstances/";

                const requestOptions = {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(data)
                };

                fetch(url, requestOptions)
                    .then((response) => {
                        if (!response.ok) {
                            if (response.status === 401)
                                document.dispatchEvent(new Event("api:unauthorized"));

                            throw new Error("Network response was not ok");
                        }
                        return response.json();
                    })
                    .then((response) => {

                    })
                    .catch((error) => {
                        console.log("Error: " + error)
                    })
                    .finally(() => {
                        setIsSavingConfiguration(false);

                    });

            })
            .catch((error) => {
                setIsSavingConfiguration(false);
                console.log("Error: ", error);
            });


    };



    const chooseSystematicReview = (srId) => {

        setChosenSystematicReview(srId);

        let defaultInstanceName = "Individual Review";

        if (chosenSystematicReviewArea == 1) defaultInstanceName = "Literature Review";
        if (chosenSystematicReviewArea == 2) defaultInstanceName = "Regulatory Intelligence";
        if (chosenSystematicReviewArea == 3) defaultInstanceName = "Market & PMS Review";
        setInstanceName(defaultInstanceName + ": " + systematicReviewsList.find(sr => sr.Id == srId)?.Title ?? defaultInstanceName);
    };


    const addCustomParamsToWidgetInstace = (widgetInstance) => {

        // Change all ids to string because dragable needs string Ids...
        widgetInstance = { ...widgetInstance, Id: "" + uniqueId.current };

        uniqueId.current += 1;

        // Add widgetInstanceId in the params for all
        widgetInstance = { ...widgetInstance, params: { widgetInstanceId: widgetInstance.Id } };


        //if (widgetInstance.IsSelectItemCheckbox)
        //    widgetInstance = { ...widgetInstance, Name: " Row selector" };



        return widgetInstance;
    };


    const deleteWidgetInstance = (widgetInstanceId) => {

        setIsDeletingWidgetInstance(widgetInstanceId);

        
        // Remove from the config list
        let newTempWidgetInstances = tempWidgetInstances.filter(instance => instance.Id != widgetInstanceId);
        setTempWidgetInstances(newTempWidgetInstances);


        // Removed all widget instances? Then load the widget list if not already there
        if (newTempWidgetInstances.length == 0 && widgets.length == 0)
            openAddWidgetModal();
        setIsDeletingWidgetInstance(null);

    }


    const openAddWidgetModal = () => {

        setNewColumnName("");
        changeNewColumnType(0);
        setShowingAddWidgetModal(true);
        setDisabledNewColumnType(false);
        setIsEdit(false);
        setIsDelete(false);
        
    };

    const closeAddWidgetModal = () => {

        setShowingAddWidgetModal(false);
        setCurrentItemId(null);
        
    };




    const addIconTo = (item) => {

        switch (item.CodeName) {

            case "newsfeed": item.Icon = "icon-feed"; break;
            case "regintelligence": item.Icon = "fas fa-file-signature"; break;
            case "literaturereviews": item.Icon = "fas fa-file-signature"; break;
            case "marketpmsvigilance": item.Icon = "fas fa-file-signature"; break;
            case "taskmanager": item.Icon = "far fa-calendar-check"; break;
            case "referencemanager": item.Icon = "fas fa-book-open"; break;
            case "compliancemanager": item.Icon = "fas fa-shield-alt"; break;
            case "submissions": item.Icon = "fas fa-file-import"; break;
            case "favorites": item.Icon = "far fa-star"; break;
            case "products": item.Icon = "fas fa-box-open"; break;
            case "countryregistrations": item.Icon = "fas fa-globe-americas"; break;
            case "companytaskmanager": item.Icon = "far fa-calendar-check"; break;
            case "srgroups": item.Icon = "fas fa-layer-group"; break;

            case "systematicreviewdetailsliterature": item.Icon = "fas fa-file-signature"; break;
            case "systematicreviewdetailsregulatory": item.Icon = "fas fa-file-signature"; break;
            case "systematicreviewdetailsmarketpms": item.Icon = "fas fa-file-signature"; break;

            default: break;
        }

        return item;

    }



    const reorder = (list, startIndex, endIndex) => {
        let result = Array.from(list);
        let [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        // Recalculate Order fields
        result = result.map((item, index) => ({ ...item, Order: index + 1 }));

        return result;
    };



    const addSSMSColumn = () => {
        if (newSSMSOptionValue == "")
            return;

        let newAnswer = {
            Id: 0,
            CustomFieldId: tempWidgetInstances.find(item => item.Id == currentItemId)?.CustomFieldId ?? 0,
            DropdownValue: newSSMSOptionValue,
            BackgroundColor: newSSMSOptionColor,
            Deleted: 0
        };

        setNewColumnSSMSOptions([...newColumnSSMSOptions, newAnswer]);
        setNewSSMSOptionValue("");
        setNewSSMSOptionColor("");
        //setNewColumnShowInTable(false);
    }


    const removeSSMSAnswer = (index) => {

        let newArray = [...newColumnSSMSOptions];
        newArray.splice(index, 1);
        setNewColumnSSMSOptions(newArray);
    }


    const changeNewColumnType = (type) => {

        setNewSSMSOptionValue("");
        setNewSSMSOptionColor("");
        setNewColumnSSMSOptions([]);
        setNewColumnType(type);

    }



    const editOrDeleteWidgetInstance = (id, isDelete=false) => {

        let item = tempWidgetInstances.find(item => item.Id == id);

        if (item) {

            setNewColumnName(item.Name);
            changeNewColumnType(item.CustomFieldType);

            setNewColumnSSMSOptions(item.DropdownValues);
            setNewColumnShowInTable(item.ShowInTable);
            
            setDisabledNewColumnType(true);

            if (isDelete) {
                setIsDelete(true);
                setIsEdit(false);
            }
            else {
                setIsEdit(true);
                setIsDelete(false);
            }

            setShowingAddWidgetModal(true);
            setCurrentItemId(item.Id);

        }

    }


    const editColumn = () => {

        setTempWidgetInstances(tempWidgetInstances.map(item => {

            if (item.Id == currentItemId) {
                item.Name = newColumnName;
                item.ShowInTable = newColumnShowInTable;
                item.DropdownValues = newColumnSSMSOptions;
                item.Updated = true;
            }

            return item;
        }
        ));

        setShowingAddWidgetModal(false);

    }

    const deleteColumn = () => {

        setTempWidgetInstances(tempWidgetInstances.filter(item => item.Id != currentItemId));

        setShowingAddWidgetModal(false);

    }


    const isDuplicateFieldTitle = (title) => {
        if (!title || !tempWidgetInstances)
            return false;

        const normalizedTitle = title.trim().toLowerCase();
        if (!normalizedTitle)
            return false;

        return tempWidgetInstances.some(item =>
            !item.IsSelectItemCheckbox &&
            item.Name &&
            item.Name.trim().toLowerCase() === normalizedTitle
        );
    };

    const createColumn = () => {

        let renderWith;
        let width = "150px";
        let order = null;

        setErrorTitle(false);
        setErrorOptions(false);

        switch (newColumnType) {

            case 0: renderWith = "FieldType_Text"; break;
            case 1: renderWith = "FieldType_CustomUserFieldSingleSelect"; break;
            case 2: renderWith = "FieldType_CustomUserFieldMultiSelect"; break;
            case 3: renderWith = "FieldType_DateList"; break;
            default: break;
        }

        if (tempWidgetInstances.length == 0)
            order = 1;
        else
            order = tempWidgetInstances[tempWidgetInstances.length - 1].Order + 1;


        if (newColumnName == "") {
            setErrorTitle(true);
            return;
        }

        if (isDuplicateFieldTitle(newColumnName)) {
            return;
        }

        if ((newColumnType == 1 || newColumnType == 2) && newColumnSSMSOptions.length == 0) {
            setErrorOptions(true);
            return;
        }

        let newCol = {

            "Id": "" + uniqueId.current++, // needs to be string for draggable
		    "CustomFieldId": null,
            "MedboardFieldId": null,
            "Name": newColumnName,
		    "EntityType": entityTypeId,
            "EntityTypeName": "",
            "CustomFieldType": newColumnType,
            "Sortable": false,
            "ShowInTable": newColumnShowInTable,
		    "Width": width,
		    "Order": order,
		    "Field": null,
		    "RenderWith": renderWith,
		    "IsSelectItemCheckbox": false,
            "IsMultiField": null,
            "DropdownValues": newColumnSSMSOptions
        }

        setTempWidgetInstances([...tempWidgetInstances, newCol]);
        setShowingAddWidgetModal(false);

    }


    const loadColumnsConfiguration = () => {

        try {

            setWidgetInstances([]);
            setTempWidgetInstances([]);
            setIsSavingWidgetInstances(false);
            setShowWidgetInstanceModal(true);
            setIsLoadingDashboard(true);

            // Load Widget Instances

            //let url = "/umbraco/api/Home/WidgetInstances";
            let url = "/umbraco/api/CustomFields/FieldsConfiguration/?entityType=" + entityTypeId;

            fetch(url)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((data) => {

                    // Inject custom arguments for specific widgetInstances

                    data = data.map(widgetInstance => {

                        // Add custom params
                        widgetInstance = addCustomParamsToWidgetInstace(widgetInstance);

                        // Add icons
                        widgetInstance = addIconTo(widgetInstance);

                        return widgetInstance;

                    });

                    setWidgetInstances(data);
                    setTempWidgetInstances(JSON.parse(JSON.stringify(data)));

                })
                .catch((error) => {
                    throw error;
                })
                .finally(() => {
                    setIsLoadingDashboard(false);
                });

            

        }
        catch (ex) {
            console.log(ex);
        }

    }




    useEffect(() => {

        //loadColumnsConfiguration();

    }, []);















    const duplicateNewFieldTitle = !isEdit && !isDelete && isDuplicateFieldTitle(newColumnName);

    return <>


        <button className="columns-configuration-button" onClick={openWidgetInstanceModal} >
            ⚙️ Add / Remove fields
        </button>
        

        {/* Widgets modal */}

        {showWidgetInstanceModal && tempWidgetInstances && (
            <div style={styles.modalOverlay}>
                <div
                    style={styles.modal}
                    onMouseDown={(e) => e.stopPropagation()}
                >
                    <div style={{display: "flex", flexDirection: "row"}}>
                        <h3>Manage Fields</h3>
                    </div>

                    {isLoadingDashboard ? <div style={{textAlign: "center"}}><LoadingSpinnerImage /></div> : <>


                        {AppContext.userRole == "Admin" && !AppContext.disableCustomFieldCreation ? <>
                            <div style={{ flex: 1, textAlign: "center", margin: "22px" }}>
                                {!showingAddWidgetModal ?
                                    <span className="add-task-button" onClick={() => openAddWidgetModal()} title="Add widget" style={{ color: "#f7f7f7", cursor: "pointer", padding: "8px 10px" }} >
                                        <i className="fas fa-plus-circle g-mr-5"></i>Add field</span>
                                    : null}
                            </div>
                        </> : null}


                        {(tempWidgetInstances.length == 0 || showingAddWidgetModal) ? <>

                            <div>
                                
                                <div style={{ display: "flex", justifyContent: "center", marginTop: "15px", fontSize: "11px" }}>
                                    {!isEdit && !isDelete && <h6>New field</h6>}
                                    {isEdit && <h6>Edit field</h6>}
                                    {isDelete && <h6>Delete field</h6>}
                                </div>
                                

                                <div style={{ display: "flex", justifyContent: "center", marginTop: "10px", marginBottom: "30px" }}>

                                    <div style={{overflow: "auto", width: "80%", backgroundColor: "#eee", borderRadius: "10px", border: "1px solid #ccc", padding: "4px 7px"}}>
                                            <>
                                                {isLoadingAddWidgetModal ? (
                                                    <div style={{ textAlign: "center" }}><LoadingSpinnerImage /></div>
                                                ) : (
                                                    <div>
                                                        <div>
                                                            <div style={{marginBottom: "10px"}}>
                                                                Field Title:
                                                            </div>
                                                            <div style={{marginBottom: "20px"}}>
                                                                <textarea type="text" style={{ width: "100%" }} onChange={(e) => setNewColumnName(e.target.value)} value={newColumnName}></textarea>
                                                            </div>
                                                            {errorTitle ? 
                                                                <div style={{ marginBottom: "20px", color: "#ff2525" }}>
                                                                    Please add a title for the field
                                                                </div>
                                                            : null}
                                                            {duplicateNewFieldTitle ?
                                                                <div style={{ marginBottom: "20px", color: "#ff2525" }}>
                                                                    A field with this title already exists
                                                                </div>
                                                            : null}
                                                            <div style={{marginBottom: "10px"}}>
                                                                Field Type:
                                                            </div>
                                                            <div style={{marginBottom: "20px"}}>
                                                                <select disabled={disabledNewColumnType} value={newColumnType} onChange={(e) => changeNewColumnType(e.target.value)} style={{ width: "100%", height: "30px" }}>
                                                                    <option value="0">Free text</option>
                                                                    <option value="1">Single Select</option>
                                                                    <option value="2">Multi Select</option>
                                                                    <option value="3">Date</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        {(newColumnType == 1 || newColumnType == 2) &&
                                                            <div style={{ marginBottom: "30px" }}>

                                                                <div style={{marginBottom: "10px"}}>Add all possible answers</div>

                                                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>

                                                                    <div style={{ width: newColumnType == 1 ? "65%" : "75%", textAlign: "center" }}>
                                                                        <input type="text" value={newSSMSOptionValue} onChange={(e) => setNewSSMSOptionValue(e.target.value)}
                                                                            placeholder="Possible answer" style={{ width: "100%", height: "30px" }} />
                                                                    </div>


                                                                    {newColumnType == 1 &&
                                                                        <div style={{ width: "10%", textAlign: "center" }}>
                                                                            

                                                                            <ColorPicker
                                                                                color={newSSMSOptionColor}
                                                                                setColor={setNewSSMSOptionColor}
                                                                            />




                                                                        </div>
                                                                    }


                                                                    <div style={{width: "25%", textAlign: "center"}}>
                                                                        <a onClick={() => addSSMSColumn()} className="btn u-btn-blue g-font-size-11 g-pl-8 g-pr-8 g-pt-2 g-pb-5 g-pt-5 g-color-white" style={{ width: "70px" }}>
                                                                            <i className="fas fa-plus-circle" style={{ marginRight: "5px" }}></i>Add
                                                                        </a>
                                                                    </div>
                                                                </div>


                                                            

                                                                <div style={{display: "flex", flexDirection: "row", marginTop: "20px"}}>
                                                                    <div style={{width: "75%"}}>
                                                                        Answer
                                                                    </div>
                                                                    <div style={{width: "25%", textAlign: "center"}}>
                                                                        Action
                                                                    </div>
                                                                </div>

                                                                {newColumnSSMSOptions.length == 0 && <div style={{textAlign: "center", color: "#adadad"}}>No answers yet...</div>}

                                                                {newColumnSSMSOptions.map((column, index) =>
                                                                    <div
                                                                        key={index}
                                                                        style={{
                                                                            display: "flex",
                                                                            flexDirection: "row",
                                                                            borderBottom: "1px solid #dadada",
                                                                            height: "20px",
                                                                            padding: "5px 5px 25px 5px"
                                                                        }}
                                                                    >
                                                                        <div style={{ width: newColumnType == 1 ? "65%" : "75%" }}>
                                                                            <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={column.DropdownValue}>
                                                                                {column.DropdownValue}
                                                                            </div>
                                                                        </div>

                                                                        {newColumnType == 1 &&
                                                                            <div style={{ width: "10%", textAlign: "center" }}>

                                                                                <ColorPicker
                                                                                    color={column.BackgroundColor}
                                                                                    setColor={(newColor) => {
                                                                                        const updatedOptions = [...newColumnSSMSOptions];

                                                                                        updatedOptions[index] = {
                                                                                            ...updatedOptions[index],
                                                                                            BackgroundColor: newColor
                                                                                        };

                                                                                        setNewColumnSSMSOptions(updatedOptions);
                                                                                    }}
                                                                                    size={20}
                                                                                />


                                                                            </div>
                                                                        }

                                                                        <div style={{ width: "25%", textAlign: "center" }}>
                                                                            <i
                                                                                className="fas fa-times-circle g-cursor-pointer"
                                                                                onClick={() => removeSSMSAnswer(index)}
                                                                                title="Delete"
                                                                            ></i>
                                                                        </div>
                                                                    </div>
                                                                )}


                                                            </div>
                                                        }


                                                        {errorOptions ?
                                                            <div style={{ marginBottom: "20px", color: "#ff2525" }}>
                                                                Please add at least one option for this field
                                                            </div>
                                                        : null}


                                                        {/*
                                                        <div style={{ marginBottom: "10px", display: "none" }}>
                                                            Display in table
                                                        </div>
                                                        <div style={{ marginBottom: "20px", display: "none" }}>
                                                            <select onChange={(e) => setNewColumnShowInTable(e.target.value == "true")} value={newColumnShowInTable} style={{width: "100%", height: "30px"}}>
                                                                <option value="false">No</option>
                                                                <option value="true">Yes</option>
                                                            </select>
                                                        </div>
                                                        */}

                                                        <div style={{ display: "flex", flexDirection: "row", marginTop: "30px" , marginBottom: "10px" }}>
                                                            <div style={{width: "50%", textAlign: "left"}}>
                                                                <a onClick={() => closeAddWidgetModal()} className="btn btn-secondary g-font-size-13 g-pl-8 g-pr-8 g-pt-2 g-pb-5 g-pt-5 border-radius-20 g-color-white">
                                                                    Cancel
                                                                </a>
                                                            </div>
                                                            <div style={{width: "50%", textAlign: "right"}}>
                                                                {!isDelete && !isEdit && 
                                                                    <a onClick={() => { if (!duplicateNewFieldTitle) createColumn(); }}
                                                                        className="btn u-btn-blue g-font-size-13 g-pl-20 g-pr-20 g-pt-2 g-pb-5 g-pt-5 border-radius-20 g-color-white"
                                                                        style={duplicateNewFieldTitle ? { pointerEvents: "none", opacity: 0.5, cursor: "not-allowed" } : {}}>
                                                                        <span>Add</span>
                                                                    </a>
                                                                }

                                                                {isEdit && 
                                                                    <a onClick={() => {editColumn()}} className="btn u-btn-blue g-font-size-13 g-pl-20 g-pr-20 g-pt-2 g-pb-5 g-pt-5 border-radius-20 g-color-white">
                                                                        <span>Edit</span>
                                                                    </a>
                                                                }

                                                                {isDelete && 
                                                                    <a onClick={() => {deleteColumn()}} className="btn u-btn-red g-font-size-13 g-pl-20 g-pr-20 g-pt-2 g-pb-5 g-pt-5 border-radius-20 g-color-white">
                                                                        <span>Delete</span>
                                                                    </a>
                                                                }
                                                            </div>

                                                        </div>
                                                    </div>
                                                )}

                                            
                                            </>
                                    </div>
                                </div>
                            </div>

                        </> : null}



                        {widgetInstances.length == 0 ? 
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <span style={{color: "#c0c0c0"}}>You don't have any fields in the table yet...</span>
                            </div>
                        : null}


                        <DragDropContext onDragEnd={onWidgetInstanceDragEnd}>

                            <Droppable droppableId="widgetInstances">
                                {(provided) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 8,
                                            height: "47vh",
                                            maxHeight: "50vh",
                                            overflowY: "auto",
                                            marginTop: 12,
                                            marginBottom: 12,
                                            paddingRight: 4,        // small padding so scrollbar doesn't overlap
                                        }}
                                        >

                                            <div style={{textAlign: "center"} }>{isSavingConfiguration ? <LoadingSpinnerImage /> : <div />}</div>

                                        {tempWidgetInstances.map((w, index) => {

                                            // Hide the checkbox column and the title/reference columns for regdocs/standards. User can't move those.


                                            if (w.EntityType == 0) // Is it a product
                                                if (w.MedboardFieldId == 2)   // Is it the product code?
                                                    return null;

                                            if (w.EntityType == 1) // Is it a product family
                                                if (w.MedboardFieldId == 2)   // Is it the family name?
                                                    return null;

                                            if (w.EntityType == 3 || w.EntityType == 4) // Is it regdocs or standards
                                                if(w.MedboardFieldId == 2) // Is it the title (regdocs) / reference (standards) field
                                                    return null;

                                            if (w.EntityType == 6) // Is it a operator
                                                if (w.MedboardFieldId == 2)   // Is it the operator name?
                                                    return null;

                                            if (w.EntityType == 7) // Is it a certificate
                                                if (w.MedboardFieldId == 2)   // Is it the Registration Certificate Reference?
                                                    return null;

                                            if (w.EntityType == 9) // Is it a registration
                                                if (w.MedboardFieldId == 2)   // Is it the product code?
                                                    return null;

                                            if (w.EntityType == 10) // Is it a submission
                                                if (w.MedboardFieldId == 1 || w.MedboardFieldId == 2)   // Is it the id or title?
                                                    return null;

                                            if (w.EntityType == 11) // Is it a submission QA
                                                if (w.MedboardFieldId == 1 || w.MedboardFieldId == 2)   // Is it the id or title?
                                                    return null;

                                            if (w.EntityType == 12) // Is it a change assessment
                                                if (w.MedboardFieldId == 1 || w.MedboardFieldId == 2)   // Is it the id or title?
                                                    return null;

                                            if (w.EntityType == 13) // Is it a relation-products-compliance-standards
                                                if (w.MedboardFieldId == 1 || w.MedboardFieldId == 2)   // Is it the id or title?
                                                    return null;

                                            if (w.EntityType == 14) // Is it a relation-products-compliance-regulations
                                                if (w.MedboardFieldId == 1 || w.MedboardFieldId == 2)   // Is it the id or title?
                                                    return null;

                                            if (w.EntityType == 16) // Is it a product-udis-eu
                                                if (w.MedboardFieldId == 1 || w.MedboardFieldId == 4)   // Is it the id or udi-di?
                                                    return null;

                                            if (w.EntityType == 17) // Is it a product-udis-us
                                                if (w.MedboardFieldId == 1 || w.MedboardFieldId == 4)   // Is it the id or udi-di?
                                                    return null;

                                            if (w.EntityType == 18) // Is it a compliance-technical-documents eTD
                                                if (w.MedboardFieldId == 1)   // Is it the title?
                                                    return null;

                                            if (w.EntityType == 19) // Is it a task
                                                if (w.MedboardFieldId == 1 || w.MedboardFieldId == 2)    // Is it the id or title?
                                                    return null;

                                            if (w.IsSelectItemCheckbox) // is it the checkbox field?
                                                return null;


                                            return (
                                                <Draggable key={w.Id} draggableId={w.Id} index={index}>
                                                    {(provided) => (

                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                padding: "8px 12px",
                                                                border: "1px solid #ddd",
                                                                borderRadius: 8,
                                                                background: "#fafafa",
                                                                ...provided.draggableProps.style,
                                                            }}
                                                        >
                                                            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                                                <div style={{ display: "flex", flexDirection: "row" }}>

                                                                    <span {...provided.dragHandleProps} style={{ cursor: "grab" }}>
                                                                        ☰
                                                                    </span>

                                                                    <div style={{ display: "flex", alignItems: "center", gap: "15px", flex: 1, marginLeft: "25px" }}>
                                                                        <span title={w.Name}>
                                                                            <i className={w.Icon} style={{ paddingRight: "5px" }}></i>
                                                                            {w.IsSelectItemCheckbox ? <i className="far fa-check-square"></i> : null}
                                                                            {w.Name.length > 100 ? `${w.Name.slice(0, 100)}(...)` : w.Name}
                                                                        </span>
                                                                    </div>

                                                                    
                                                                    {/*w.MedboardFieldId != null ?
                                                                        <div>
                                                                            <span>
                                                                                <img src="https://app.medboard.com/media/cbaew04v/logo.svg" alt="Medboard field" style={{ maxHeight: "20px", minHeight: "10px" }} />
                                                                            </span>
                                                                        </div>
                                                                    : null*/}


                                                                    <div style={{ minWidth: "85px", textAlign: "center" }}>
                                                                        <input
                                                                            title="Display in table"
                                                                            type="checkbox"
                                                                            checked={w.ShowInTable}
                                                                            onChange={(e) => { toggleTempWidgetInstance(w.Id, e.target.checked); }}
                                                                        />

                                                                        {w.MedboardFieldId != null ?
                                                                            null
                                                                            :
                                                                            <>

                                                                                {(w.MedboardFieldId == null && AppContext.userRole == "Admin") && (<>
                                                                                    <span
                                                                                        title="Edit"
                                                                                        onClick={() => editOrDeleteWidgetInstance(w.Id)}
                                                                                        style={{ marginLeft: "15px", cursor: "pointer" }}
                                                                                    >
                                                                                        <i className="fas fa-edit"></i>
                                                                                    </span>

                                                                                    <span
                                                                                        title="Delete"
                                                                                        onClick={() => editOrDeleteWidgetInstance(w.Id, true)}
                                                                                        style={{ marginLeft: "15px", cursor: "pointer" }}
                                                                                    >
                                                                                        <i className="fas fa-times-circle"></i>
                                                                                    </span>
                                                                                </>
                                                                                )}
                                                                            </>
                                                                        }
                                                                    </div>

                                                                </div>

                                                            </div>


                                                        </div>

                                                    )}
                                                </Draggable>
                                            )
                                        })}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>

                        </DragDropContext>


                        <div style={styles.controlRow}>
                            <button style={styles.btn} onClick={cancelWidgetInstanceModal}>
                                Cancel
                            </button>
                            {isSavingWidgetInstances ? <div><LoadingSpinnerImage /></div> :
                                <button style={styles.btnPrimary} onClick={saveWidgetInstanceModal}>
                                    Save
                                </button>
                            }
                        </div>


                    </>}

                </div>
            </div>
        )}



    </>




}

const styles = {
    page: {
        fontFamily:
            "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
        background: "#f0f2f5",
        padding: 16,
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #c9ddff 0px, #f0f2f5 250px)",
    },
    appBar: {
        display: "flex",
        alignItems: "initial",
        gap: 12,
        padding: "8px 12px",
        borderRadius: 8,
        marginBottom: 16,
        justifyContent: "center",
        maxWidth: "100%",
        overflow: "auto",
    },
    appIcon: {
        width: 55,
        height: 55,
        borderRadius: 40,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        textAlign: "center",
        textDecoration: "none",
        background: "#fff",
        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
        transition: "all 0.2s ease"
    },
    manageBtn: {
        background: "transparent",
        border: "none",
        cursor: "pointer",
        fontSize: 18,
        padding: 8,
    },
    twoCols: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 16,
    },
    col: {
        display: "flex",
        flexDirection: "column",
        gap: 16,
    },
    modalOverlay: {
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
    },
    modal: {
        width: 560,
        maxHeight: "92vh",
        overflow: "auto",
        background: "#fff",
        borderRadius: 10,
        padding: 18,
        boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
    },
    controlRow: {
        display: "flex",
        justifyContent: "flex-end",
        gap: 30,
        marginTop: 12,
    },
    btn: {
        padding: "8px 12px",
        borderRadius: 8,
        border: "1px solid #ddd",
        background: "#fff",
        cursor: "pointer",
    },
    btnPrimary: {
        padding: "8px 12px",
        borderRadius: 8,
        border: "none",
        background: "#2563eb",
        color: "white",
        cursor: "pointer",
    },
    smallInput: {
        padding: 6,
        borderRadius: 6,
        border: "1px solid #ccc",
    },
};

export default ColumnsConfiguration;
